module.exports = __webpack_public_path__ + "img/InvitaYgana_bgimg.cc4c4d05.png";